import React, { useRef } from 'react';
import BaseModal, { modalSizes } from 'flow/components/ui-components/BaseModal';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import UserRegionDropdown from '../region-lookup/UserRegionDropdown';
import Icon from '../ui-components/Icon';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { useUserRegionData } from 'flow/hooks/region-lookup/useUserRegionData';
import {
    createReturnUrl,
    MSGOO_APP_REG_DEFAULT_VALUE,
} from 'flow/utils/social-integration-utils';
import { electronListeners } from 'flow/utils/electron-utils';
import { startExternalSignIn } from 'flow/actions/social-integration-actions';
import { SocialLoginType } from 'flow/types/region-lookup/UserRegion';
import isElectron from 'is-electron';
import { startCtiExternalSignIn } from 'flow/route-components/cti-sso';
import { SYNC_SOURCE } from 'flow/utils/constants/app-constants';

const UserRegionSelectorModal = () => {
    const { i18next } = useAppContext();
    const { regionData, updateRegionData } = useUserRegionData();
    const { closeModal } = useModal();
    const dispatch = useAppDispatch();
    const socialLoginTypeRef = useRef(regionData?.socialLoginType);

    const electronSignInProcess = (
        socialLoginType: SocialLoginType,
        appRegId: string | null,
    ) => {
        electronListeners.checkIfExternalSignInFinished(dispatch);
        const callbackUrl = createReturnUrl('dummy', socialLoginType);
        dispatch(startExternalSignIn(socialLoginType, callbackUrl, appRegId));
    };

    const startSignIn = () => {
        const socialLoginType = socialLoginTypeRef.current;
        if (regionData && socialLoginType) {
            const appRegId = MSGOO_APP_REG_DEFAULT_VALUE;
            if (
                socialLoginType === SYNC_SOURCE.google ||
                socialLoginType === SYNC_SOURCE.microsoft
            ) {
                updateRegionData({
                    ...regionData,
                    socialLoginType,
                    url: regionData?.socialSelectedUrl,
                });

                if (isElectron()) {
                    electronSignInProcess(socialLoginType, appRegId);
                } else {
                    startCtiExternalSignIn(socialLoginType, appRegId);
                }
            }
        }
    };

    return (
        <BaseModal
            open={true}
            ariaLabel={i18next.t('signin.social.region.unsuccess')}
            modalSize={modalSizes.SMALL}
            hideCancelButton={false}
            confirmButtonText={i18next.t('signin.social.region.button.retry')}
            onSubmit={startSignIn}
            onClose={closeModal}
            isFooterActionsMultiRow={true}
            mainClassName={
                'max-h-[calc(100%-240px)] md:max-h-[calc(100%-140px)]'
            }
        >
            <div className="flex flex-col gap-y-3 px-2">
                <div className="flex justify-center">
                    <Icon
                        className="text-lg"
                        style={{ width: 48, height: 48 }}
                        iconKey="globeQuestion"
                    />
                </div>
                <p className="text-sm">
                    {i18next.t('signin.social.region.unsuccess')}
                </p>
                <UserRegionDropdown isModal={true} />
            </div>
        </BaseModal>
    );
};

export default UserRegionSelectorModal;
